import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import * as services from 'modules/auth/services/logout';
import { disconnectWS } from 'modules/websocket/WSManager';
import checkIsMobile from 'shared/utils/checkMobileDevice';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { resetDeepLink } from 'modules/common/actions/deepLink';
import { addModal } from 'modules/messageSystem/actions/addModal';
import { clearModalQueue } from 'modules/messageSystem/actions/clearModalQueue';
import { releaseFirebase } from 'modules/notifications/actions/releaseFirebase';
import { stopConsultationLocal } from 'modules/conference/actions/stopConsultation';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { workerUninstall } from 'modules/notifications/actions/serviceWorkerUninstall';
import { fetchActiveConversations } from 'modules/session/actions/fetchActiveConversations';
import { remoteVideoNotInDefaultState } from 'modules/conference/selectors/connectionStatus';
import { stopAvailabilityPing } from 'modules/serviceWorker/actions/startStopAvailabilityPing';
import {
  SIGN_OUT_MODAL,
  MODAL_SIGN_OUT_DURING_CONSULTATION,
  MODAL_SIGN_OUT_TO_PROCEED,
} from 'modules/messageSystem/constants/modalCodes';

import createAction from './';
import { replaceTo } from './redirectAction';


export const LOGOUT = createAsyncAction(createAction('LOGOUT'));

const notifyReactNative = () => {
  if (/RnUmmanu/.test(navigator.userAgent)) {
    window.ReactNativeWebView?.postMessage(JSON.stringify({
      action: 'LOGOUT',
    }));
  }
};

export const logout = (withoutApiCall = false, isSessionExpired = false) => (dispatch, getState) => {
  dispatch({ type: LOGOUT.pending });

  stopAvailabilityPing();

  if (/RnUmmanu/.test(navigator.userAgent)) {
    window.ReactNativeWebView?.postMessage(JSON.stringify({
      action: 'LOGOUT',
    }));
  }

  return Promise.resolve()
    .then(() => conferenceInProgress(getState()) ? dispatch(stopConsultationLocal()) : null)
    .then(() => dispatch(clearModalQueue()))
    .then(() => {
      dispatch(resetDeepLink());

      if (withoutApiCall) return;
      const apiCallParams = { mutation: services.LOGOUT };

      return apiCall(apolloClient.mutate, apiCallParams);
    })
    .then(() => localStorage.removeItem('jwt'))
    .then(() => dispatch({ type: LOGOUT.success }))
    .then(() => dispatch(workerUninstall()))
    .then(() => {
      if (checkIsMobile() && !isSessionExpired) {
        return dispatch(releaseFirebase());
      }

      return null;
    })
    .catch((err) => dispatch(errorAction(LOGOUT.failure, err)))
    .finally(() => {
      disconnectWS();
      notifyReactNative();
    });
};


export const logoutWithModal = () => (dispatch, getState) => {
  fetchActiveConversations()
    .then(({ appointmentId }) => {
      if (remoteVideoNotInDefaultState(getState()) || appointmentId) {
        return dispatch(addModal({
          testId: 'sign-out-during-consultation-modal',
          typeId: MODAL_SIGN_OUT_DURING_CONSULTATION,
        }));
      }

      dispatch(addModal({
        testId: 'sign-out-modal',
        typeId: SIGN_OUT_MODAL,
        onOk: () => dispatch(logout()),
      }));
    });
};


export const askLogoutWithSelectedOrganization = () => (dispatch, getState) => {
  dispatch(
    addModal({
      testId: 'sign-out-to-proceed-modal',
      typeId: MODAL_SIGN_OUT_TO_PROCEED,
      onDismiss: () => replaceTo('/appointments'),
      onCancel: () => replaceTo('/appointments'),
      onOk: () => {
        fetchActiveConversations()
          .then(({ appointmentId }) => {
            if (remoteVideoNotInDefaultState(getState()) || appointmentId) {
              replaceTo('/appointments');

              return dispatch(addModal({ typeId: MODAL_SIGN_OUT_DURING_CONSULTATION }),
              );
            }

            dispatch(logout());
          });
      },
    }),
  );
};
